// Topics shown in the vector space view. Names must match TOPIC_DESCRIPTIONS in
// backend/main.py (the backend assigns them); "other" is the fallback.
export const TOPICS = [
  { name: 'music', color: '#f87171' },
  { name: 'psychology', color: '#fb923c' },
  { name: 'philosophy', color: '#fbbf24' },
  { name: 'technology', color: '#34d399' },
  { name: 'personal', color: '#22d3ee' },
  { name: 'work', color: '#818cf8' },
  { name: 'health', color: '#a78bfa' },
  { name: 'relationships', color: '#f472b6' },
  { name: 'creativity', color: '#e879f9' },
  { name: 'learning', color: '#67e8f9' },
  { name: 'planning', color: '#38bdf8' },
  { name: 'chitchat', color: '#a8a29e' },
  { name: 'diet', color: '#a3e635' },
  { name: 'exercise', color: '#2dd4bf' },
  { name: 'chores', color: '#b45309' },
  { name: 'other', color: '#94a3b8' },
];

export const TOPIC_NAMES = TOPICS.map(t => t.name);

export const TOPIC_COLORS: Record<string, number> = Object.fromEntries(
  TOPICS.map(t => [t.name, parseInt(t.color.slice(1), 16)])
);
